import { Injectable } from '@angular/core';
import { EmployeeInterface } from './definitions/employee-interface';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface EmployeesSendChangePasswordResponse {
  employee: EmployeeInterface;
}

@Injectable()
export class EmployeeSendChangePasswordService {
  constructor(private apollo: Apollo) {}

  sendChangePassword(
    userId: string,
    mutation: DocumentNode
  ): Observable<FetchResult<EmployeesSendChangePasswordResponse>> {
    return this.apollo.mutate<EmployeesSendChangePasswordResponse>({
      mutation: mutation,
      variables: {
        userId: userId,
      },
    });
  }
}
